<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="b"><rect width="24" height="24" /></clipPath>
    </defs>
    <g id="a" clip-path="url(#b)">
      <path
        d="M19.73,33.811,16.373,22.618a1.827,1.827,0,0,0-2.244-1.209L9.873,22.686a1.649,1.649,0,0,0-3.271.3H1.651A1.652,1.652,0,0,0,0,24.634V37.013a1.652,1.652,0,0,0,1.651,1.651H5.3a1.8,1.8,0,0,0,2.028.75l11.194-3.358a1.791,1.791,0,0,0,1.285-1.726A1.769,1.769,0,0,0,19.73,33.811ZM8.253,22.158a.82.82,0,0,1,.814.769l-.187.056H7.427A.826.826,0,0,1,8.253,22.158Zm.825,1.628v2.086a.413.413,0,0,1-.825,0V24.033ZM1.651,37.839a.826.826,0,0,1-.825-.825V24.634a.826.826,0,0,1,.825-.825H6.129l-3.194.958a1.791,1.791,0,0,0-1.285,1.726,1.769,1.769,0,0,0,.077.518L4.975,37.839Zm16.634-2.574L7.091,38.623a.99.99,0,0,1-1.217-.655L2.517,26.773a.953.953,0,0,1-.041-.279.97.97,0,0,1,.7-.936l4.255-1.277v1.591a1.238,1.238,0,1,0,2.476,0V23.538L14.366,22.2a.978.978,0,0,1,1.217.655L18.94,34.049a.953.953,0,0,1,.041.279A.97.97,0,0,1,18.285,35.264Z"
        transform="translate(2.193 -19.739)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'PostWallIcon',
};
</script>
